import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { withUserConsumer } from '@bingads-webui-react/user-context';
import { memoize } from '@bingads-webui-universal/primitive-utilities';

import { useYahooModel } from './yahoo-helpers';
import { siteMapPropType } from '../site-map-prop-type';

const processSitemap = (siteMap, yahooModel) => _.map(siteMap, (item) => {
  const retItem = item;
  if (item.baseHost === 'ClientCenterBaseUrl') {
    if (item.onlyShowToYahoo) {
      return yahooModel && yahooModel.canUserAccessYahooData ? item : null;
    }
    retItem.children = _.map(item.children, (child) => {
      if (child.onlyShowToYahoo) {
        return yahooModel && yahooModel.canUserAccessYahooData ? child : null;
      }
      return child;
    }).filter(child => child !== null);
  }
  return retItem;
});

const processSitemapCached = memoize(processSitemap);

export function processShowYahoo(Component, useCache = false) {
  const Wrapper = ({ siteMap, userContext, ...props }) => {
    const { params } = props;
    const permissions = _.defaults(props.permissions, { dynamic: {} });
    const { CurrentUser, CurrentCustomer } = userContext;

    const yahooModel = useYahooModel(params, permissions, CurrentUser, CurrentCustomer);

    const processorFunc = useCache ? processSitemapCached : processSitemap;
    const processedSiteMap = processorFunc(siteMap, yahooModel).filter(child => child !== null);

    return (<Component {...props} siteMap={processedSiteMap} />);
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
    permissions: PropTypes.objectOf(PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.objectOf(PropTypes.bool),
      PropTypes.number,
    ])).isRequired,
    userContext: PropTypes.objectOf(PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.number])),
      PropTypes.number,
    ])).isRequired,
    params: PropTypes.objectOf(PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.objectOf(PropTypes.bool),
      PropTypes.number,
    ])).isRequired,
  };

  return withUserConsumer(Wrapper);
}
